import React, { useState, useEffect } from 'react';
import { NavLink, withRouter } from 'react-router-dom';
import Switch from '@mui/material/Switch';
// import useForm from 'react-hook-form'

import { GET, POST, newFetch } from '../../../../../helpers/fetch';
import { config } from '../../../../../config/index';
import LayoutContext from '../../../../../store/Layout/contexts';
import { Form, Col, Row } from 'react-bootstrap';
import ToastUtil from '../../../../../components/ToastNotification/ToastUtil';
import AlertService from '../../../../../components/SweetAlert';

const { API_URL } = config;

const AddClient = ({ history }) => {
  const token = localStorage.getItem('token');
  const [name, setName] = useState('');
  const [managerFirstName, setManagerFirstName] = useState('');
  const [managerLastName, setManagerLastName] = useState('');
  const [email, setEmail] = useState('');
  const [phoneNo, setPhoneNo] = useState('');
  const [smartScheduler, setSmartScheduler] = useState(false);
  const [performanceManagement, setPerformanceManagement] = useState(false);
  const [reward, setReward] = useState(false);
  const [event, setEvent] = useState(false);
  const [communication, setCommunication] = useState(false);
  const [troubleTicketing, setTroubleTicketing] = useState(false);
  const [leaveCredits, setLeaveCredits] = useState(false);
  const [claims, setClaims] = useState(false);
  const [catalogue, setCatalogue] = useState(false);
  const [deliveryOrder, setDeliveryOrder] = useState(false);
  const [edocs, setEdocs] = useState(false);
  const [startDay, setStartDay] = useState(0);

  const [validated, setValidated] = useState(false);

  const nameHandler = (e) => setName(e.target.value);
  const managerFirstNameHandler = (e) => setManagerFirstName(e.target.value);
  const managerLastNameHandler = (e) => setManagerLastName(e.target.value);
  const emailHandler = (e) => setEmail(e.target.value);
  const phoneNoHandler = (e) => setPhoneNo(e.target.value);
  const smartSchedulerHandler = (e) => setSmartScheduler(e.target.checked);
  const startDayHandler = (e) => setStartDay(e.target.value);
  const [escalationContacts, setEscalationContacts] = useState([]);
  const [SEVs, setSEVs] = useState([]);

  useEffect(() => {
    const fetchSEVs = async () => {
      let api_path = '/tt/severity';
      let response = await newFetch(GET, api_path);

      if (response.success) {
        setSEVs(response.data);
      }
    };

    fetchSEVs();
  }, []);

  const addContacts = () => {
    if (SEVs.length > 0) {
      setEscalationContacts([
        ...escalationContacts,
        {
          first_name: '',
          last_name: '',
          email: '',
          sev_id: 1,
        },
      ]);
    } else {
      ToastUtil.error(' not been defined.');
    }
  };

  const removeContact = (index) =>
    setEscalationContacts(
      [...escalationContacts].filter((contacts, i) => i !== index)
    );

  const updateContactFirstNameHandler = (i, e) => {
    let clone = [...escalationContacts];
    clone[i].first_name = e.target.value;
    setEscalationContacts(clone);
  };

  const updateContactLastNameHandler = (i, e) => {
    let clone = [...escalationContacts];
    clone[i].last_name = e.target.value;
    setEscalationContacts(clone);
  };

  const updateContactEmailHandler = (i, e) => {
    let clone = [...escalationContacts];
    clone[i].email = e.target.value;
    setEscalationContacts(clone);
  };

  const updateContactSEVHandler = (i, e) => {
    let clone = [...escalationContacts];
    clone[i].sev_id = e.target.value;
    setEscalationContacts(clone);
  };

  const discardHandler = async () => {
    if (
      await AlertService.confirm(
        '',
        'Are you sure you want to discard all changes?'
      )
    ) {
      setName('');
      setManagerFirstName('');
      setManagerLastName('');
      setEmail('');
      setPhoneNo('');
      setSmartScheduler(false);
      setPerformanceManagement(false);
      setReward(false);
      setEvent(false);
      setCommunication(false);
      setTroubleTicketing(false);
      setLeaveCredits(false);
      setClaims(false);
      setStartDay(0);
      setEscalationContacts([]);
      setCatalogue(false);
      setDeliveryOrder(false);
      setEdocs(false);
    }
  };

  const handleSubmit = async (event) => {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    } else {
      await submitHandler(event);
    }

    setValidated(true);
  };

  const submitHandler = async (e) => {
    e.preventDefault();
    if (
      await AlertService.confirm(
        '',
        'Are you sure you want to add this Client?'
      )
    ) {
      const data = {
        name,
        manager_first_name: managerFirstName,
        manager_last_name: managerLastName,
        email,
        phone_no: phoneNo,
        enable_smart_scheduler: smartScheduler,
        enable_performance_management: performanceManagement,
        enable_reward: reward,
        enable_event: event,
        enable_communication: communication,
        enable_trouble_ticketing: troubleTicketing,
        enable_leave_credits: leaveCredits,
        enable_claims: claims,
        enable_catalogue: catalogue,
        enable_delivery_order: deliveryOrder,
        enable_edocs: edocs,
        start_day: parseInt(startDay),
        contacts: escalationContacts,
      };

      let api_path = '/client/create';
      let response = await newFetch(POST, api_path, data);

      if (response.success) {
        ToastUtil.success(response.message);
        history.push('/clients');
      }
    }
  };

  return (
    <LayoutContext.Consumer>
      {({ activeSidebar }) => (
        <div style={{ paddingTop: '3rem' }}>
          <div
            className="d-flex flex-column"
            style={{ paddingLeft: '3rem', paddingRight: '3rem' }}
          >
            <NavLink
              to="/clients"
              className="text-decoration-none"
              style={{ color: 'inherit' }}
            >
              <div style={{ color: '#0d6efd' }}>
                <i className="fas fa-chevron-left pe-2"></i>Back to Client
                Management
              </div>
            </NavLink>
            <div className="pt-4">
              <h5>Add Client</h5>
            </div>
          </div>
          <Form noValidate validated={validated} onSubmit={handleSubmit}>
            <div
              className="border rounded d-flex"
              style={{
                marginTop: '2rem',
                marginLeft: '3rem',
                marginRight: '3rem',
              }}
            >
              <div
                style={{
                  width: '15rem',
                  backgroundColor: '#f3f3f3',
                  padding: '2.25rem',
                }}
                className="border-right"
              >
                <strong>Client Information</strong>
                <p className="pt-2">Manage client's information</p>
              </div>
              <div
                className="flex-grow-1 bg-white"
                style={{ padding: '2.25rem' }}
              >
                <Row className="mb-3">
                  <Form.Group as={Col} md="12">
                    <Form.Label>
                      <strong>Client Name</strong>
                    </Form.Label>
                    <Form.Control
                      required
                      type="text"
                      value={name}
                      placeholder="Client Name*"
                      onChange={(e) => nameHandler(e)}
                      maxLength={200}
                    />
                    <Form.Control.Feedback type="invalid">
                      Please enter client name.
                    </Form.Control.Feedback>
                  </Form.Group>
                </Row>
              </div>
            </div>
            <div
              className="border rounded d-flex"
              style={{
                marginTop: '2rem',
                marginLeft: '3rem',
                marginRight: '3rem',
              }}
            >
              <div
                style={{
                  width: '15rem',
                  backgroundColor: '#f3f3f3',
                  padding: '2.25rem',
                }}
                className="border-right"
              >
                <strong>Client Contact</strong>
                <p className="pt-2">Manage client contact information</p>
              </div>
              <div
                className="flex-grow-1 bg-white"
                style={{ padding: '2.25rem' }}
              >
                <Row className="mb-3">
                  <Form.Group as={Col} md="6">
                    <Form.Label>
                      <strong>First Name</strong>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      value={managerFirstName}
                      placeholder="Client Contact First Name"
                      onChange={(e) => managerFirstNameHandler(e)}
                      maxLength={100}
                    />
                  </Form.Group>
                  <Form.Group as={Col} md="6">
                    <Form.Label>
                      <strong>Last Name</strong>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      value={managerLastName}
                      placeholder="Client Contact Last Name"
                      onChange={(e) => managerLastNameHandler(e)}
                      maxLength={100}
                    />
                  </Form.Group>
                </Row>
                <Row className="mb-3">
                  <Form.Group as={Col} md="12">
                    <Form.Label>
                      <strong>Email*</strong>
                    </Form.Label>
                    <Form.Control
                      required
                      type="email"
                      value={email}
                      placeholder="Email"
                      onChange={(e) => emailHandler(e)}
                      maxLength={150}
                    />
                    <Form.Control.Feedback type="invalid">
                      Please enter valid email.
                    </Form.Control.Feedback>
                    <small className="form-text text-muted mt-3">
                      Log in credentials and instructions will be sent to this
                      email once the client is added.
                    </small>
                  </Form.Group>
                </Row>
                <Row>
                  <Form.Group as={Col} md="12">
                    <Form.Label>
                      <strong>Phone No</strong>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      value={phoneNo}
                      placeholder="phoneNo"
                      onChange={(e) => phoneNoHandler(e)}
                      maxLength={20}
                    />
                  </Form.Group>
                </Row>
              </div>
            </div>
            <div
              className="border rounded d-flex"
              style={{
                marginTop: '2rem',
                marginLeft: '3rem',
                marginRight: '3rem',
              }}
            >
              <div
                style={{
                  width: '15rem',
                  backgroundColor: '#f3f3f3',
                  padding: '2.25rem',
                }}
                className="border-right"
              >
                <strong>Settings</strong>
                <p className="pt-2">Manage settings</p>
              </div>
              <div
                className="flex-grow-1 bg-white"
                style={{ padding: '2.25rem' }}
              >
                <div className="row">
                  <div className="col-sm-12 d-flex align-items-center justify-content-between pb-3">
                    <strong>Enable Smart Scheduler</strong>
                    <Switch
                      checked={smartScheduler}
                      onChange={(e) => smartSchedulerHandler(e)}
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-12 d-flex align-items-center justify-content-between pb-3">
                    <strong>Enable Leave Credits & Filling</strong>
                    <Switch
                      checked={leaveCredits}
                      onChange={({ target: { checked } }) =>
                        setLeaveCredits(checked)
                      }
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-12 d-flex align-items-center justify-content-between pb-3">
                    <strong>Enable Claims</strong>
                    <Switch
                      checked={claims}
                      onChange={({ target: { checked } }) => setClaims(checked)}
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-12 d-flex align-items-center justify-content-between pb-3">
                    <strong>Enable Trouble Ticketing</strong>
                    <Switch
                      checked={troubleTicketing}
                      onChange={({ target: { checked } }) =>
                        setTroubleTicketing(checked)
                      }
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-12 d-flex align-items-center justify-content-between pb-3">
                    <strong>Enable Performance Management</strong>
                    <Switch
                      checked={performanceManagement}
                      onChange={({ target: { checked } }) =>
                        setPerformanceManagement(checked)
                      }
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-12 d-flex align-items-center justify-content-between pb-3">
                    <strong>Enable Communication</strong>
                    <Switch
                      checked={communication}
                      onChange={({ target: { checked } }) =>
                        setCommunication(checked)
                      }
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-12 d-flex align-items-center justify-content-between pb-3">
                    <strong>Enable Reward</strong>
                    <Switch
                      checked={reward}
                      onChange={({ target: { checked } }) => setReward(checked)}
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-12 d-flex align-items-center justify-content-between pb-3">
                    <strong>Enable Event</strong>
                    <Switch
                      checked={event}
                      onChange={({ target: { checked } }) => setEvent(checked)}
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-12 d-flex align-items-center justify-content-between pb-3">
                    <strong>Enable Catalogue</strong>
                    <Switch
                      checked={catalogue}
                      onChange={({ target: { checked } }) => setCatalogue(checked)}
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-12 d-flex align-items-center justify-content-between pb-3">
                    <strong>Enable Delivery Order</strong>
                    <Switch
                      checked={deliveryOrder}
                      onChange={({ target: { checked } }) => setDeliveryOrder(checked)}
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-12 d-flex align-items-center justify-content-between pb-3">
                    <strong>Enable Edocs</strong>
                    <Switch
                      checked={edocs}
                      onChange={({ target: { checked } }) => setEdocs(checked)}
                    />
                  </div>
                </div>
                <div className="row pt-3">
                  <div className="col-sm-4">
                    <strong>Start day of the week:</strong>
                    <select
                      name=""
                      id=""
                      className="form-select mt-3 adjust-fs"
                      value={startDay}
                      onChange={(e) => startDayHandler(e)}
                    >
                      <option value="0">Sun-Sat</option>
                      <option value="1">Mon-Sun</option>
                      <option value="2">Sat-Fri</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>

            <div
              className="border rounded d-flex"
              style={{
                marginTop: '2rem',
                marginLeft: '3rem',
                marginRight: '3rem',
                marginBottom: '6rem',
              }}
            >
              <div
                style={{
                  width: '15rem',
                  backgroundColor: '#f3f3f3',
                  padding: '2.25rem',
                }}
                className="border-right"
              >
                <strong>Escalation Contacts</strong>
                <p className="pt-2">Manage escalation contacts</p>
              </div>
              <div
                className="flex-grow-1 bg-white"
                style={{ padding: '2.25rem' }}
              >
                {escalationContacts.map((contact, index) => (
                  <div className="pb-3" key={index}>
                    <div className="d-flex justify-content-between">
                      <strong>Contact</strong>
                      <h6
                        style={{ cursor: 'pointer' }}
                        className="text-danger"
                        onClick={() => removeContact(index)}
                      >
                        <i className="fas fa-trash"></i>&nbsp;&nbsp;&nbsp;Remove
                      </h6>
                    </div>
                    <div
                      className="border rounded mt-3"
                      style={{ padding: '2.25rem' }}
                    >
                      <div className="row">
                        <div className="col-sm-6">
                          <strong>First Name</strong>
                          <input
                            type="text"
                            className="form-control mt-3"
                            value={contact.first_name}
                            onChange={(e) =>
                              updateContactFirstNameHandler(index, e)
                            }
                          />
                        </div>
                        <div className="col-sm-6">
                          <strong>Last Name</strong>
                          <input
                            type="text"
                            className="form-control mt-3"
                            value={contact.last_name}
                            onChange={(e) =>
                              updateContactLastNameHandler(index, e)
                            }
                          />
                        </div>
                      </div>
                      <div className="row pt-3">
                        <div className="col-sm-8">
                          <strong>Email</strong>
                          <input
                            type="email"
                            className="form-control mt-3"
                            value={contact.email}
                            onChange={(e) =>
                              updateContactEmailHandler(index, e)
                            }
                          />
                        </div>
                        <div className="col-sm-4">
                          <strong>SEV Level</strong>
                          <select
                            className="form-select mt-3 adjust-fs"
                            value={contact.sev_id}
                            onChange={(e) => updateContactSEVHandler(index, e)}
                          >
                            {SEVs &&
                              SEVs.length > 0 &&
                              SEVs.map((sev) => (
                                <option key={sev.id} value={sev.id}>
                                  {sev.name}
                                </option>
                              ))}
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
                <div
                  onClick={() => addContacts()}
                  className="border rounded mt-3"
                  style={{
                    paddingLeft: '2.25rem',
                    paddingRight: '2.25rem',
                    paddingTop: '1.5rem',
                    paddingBottom: '1.5rem',
                    cursor: 'pointer',
                  }}
                >
                  <i className="fas fa-plus"></i>&nbsp;&nbsp;&nbsp;
                  <strong>Add Another Contact</strong>
                </div>
              </div>
            </div>

            <div
              style={{
                position: 'fixed',
                bottom: 0,
                width: activeSidebar ? 'calc(100vw - 310px)' : '100vw',
                height: '4.5rem',
                paddingRight: '3rem',
              }}
              className="border-top bg-white d-flex align-items-center justify-content-end"
            >
              <button
                type="button"
                onClick={discardHandler}
                className="btn btn-outline-brand adjust-fs adjust-shadow"
                style={{ width: '12rem' }}
              >
                Discard
              </button>
              <button
                type="submit"
                className="btn btn-brand ms-3 adjust-fs adjust-shadow"
                style={{ width: '12rem' }}
              >
                Save changes
              </button>
            </div>
          </Form>
        </div>
      )}
    </LayoutContext.Consumer>
  );
};

export default withRouter(AddClient);
